import {
  buildForest,
  type NamedHierarchyNode,
  type TreeNode,
} from "@contract-manager/shared";

export interface MoveDestination {
  readonly id: string;
  readonly name: string;
  readonly depth: number;
}

/**
 * The nodes `moved` can be put under, in the order the tree draws them.
 *
 * The moved node's own subtree is left out: the server refuses a move into it
 * anyway, and offering a choice that can only fail is worse than not offering
 * it. Nesting too deeply is still left to the server, which knows the limit.
 */
export function moveDestinations(
  nodes: readonly NamedHierarchyNode[],
  moved: NamedHierarchyNode,
): MoveDestination[] {
  const walk = (
    branch: readonly TreeNode<NamedHierarchyNode>[],
    depth: number,
  ): MoveDestination[] =>
    branch
      .filter((node) => node.id !== moved.id)
      .flatMap((node) => [
        { id: node.id, name: node.name, depth },
        ...walk(node.children, depth + 1),
      ]);

  return walk(buildForest(nodes), 0);
}
